module.exports = __webpack_public_path__ + "static/media/JGN-BNB.5eba7740.svg";